<template>
  <div class="results-order">
    <div class="row">
      <div class="fake-form-field form-field--stretch form-field--style-1 form-field--no-asterisk col">

        <!-- title -->
        <div
            v-if="showTitle"
            class="filter-label"
        >
          <i class="fas fa-sort d-none d-sm-block"></i>
          <label class="col-form-label">
            {{ $t('messages_nl.search-form.sortFilterTitle') }}
          </label>
        </div>

        <!-- select order -->
        <select
            id="sortBy"
            v-model="sortSelected"
            name="sortBy"
            class="form-control results-order"
            @click="$emit('clicked')"
        >
          <option
              v-for="(option, index) in sortOptions"
              :key="index"
              :value="option.value"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import * as constants from "../../../../../common/vue/constants";

export default {
  name: "adivare-results-order",
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    },
    forceUpdateFilters: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['clicked'],
  computed: {
    sortOptions () {
      return this.$store.state.availableFilters.sortOptions;
    },
    sortSelected: {
      get() {
        return this.$store.state.filters.sorting;
      },
      set(selected) {
        if (true === this.forceUpdateFilters) {
          this.$store.commit('updateRequest', constants.REQUEST_HOUSES);
          this.$store.commit('updateSortSelected', selected);

          return;
        }

        this.$emit('updateFilters', {sorting: selected});
        this.$emit('updateCounts', {sorting: selected});
      }
    }
  }
}
</script>
